module.exports = __webpack_public_path__ + "img/QR.9fedb875.png";